import { Suspense, FC, ReactNode } from 'react'

import LoadingIndicator from './layout/loading'
interface Props {
  children: ReactNode
  fallback?: ReactNode
}

const SuspenseWrapper: FC<Props> = ({ children, fallback = <LoadingIndicator /> }) => {
  return <Suspense fallback={fallback}>{children}</Suspense>
}

export default SuspenseWrapper
